import React, { useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";
import { Link} from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import {
  GetService,
  PostFormData
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import defaultImg from "../../../../assets/img/thumbnail.png";

export default function BioVideo() {
  const [ValueObj, setValueObj] = useState({});
  const [DataObj, setDataObj] = useState("");
  const [image, setimage] = useState("");
  const [video, setvideo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    setLoading(true);
    GetService(`${API_URL.GET_BIO_DETAIL}`).then((res) => {
      // console.log(res);
      if (res.data?.status === true) {
        setValueObj({
          title: res?.data?.data?.title || "",
          bio: res?.data?.data?.bio || "",
          description: res?.data?.data?.description || "",
          image: "",
          video: "",
        });
        setimage(res?.data?.data?.image)
        setvideo(res?.data?.data?.video)
        setDataObj(res?.data?.data);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  function submit() {
    console.log(ValueObj);
    if (!ValueObj?.title || !ValueObj?.description || !ValueObj?.bio ) {
      setError(true);
      return;
    } 
    const formdata = new FormData();
    formdata.append("id", DataObj?.id);
    formdata.append("title", ValueObj?.title);
    formdata.append("bio", ValueObj?.bio);
    formdata.append("description", ValueObj?.description);
    formdata.append("image", ValueObj?.image);
    formdata.append("video", ValueObj?.video);
    setsubmitLoader(true);
    PostFormData(API_URL.UPDATE_BIO, formdata).then(
      (res) => {
        if (res.data.status === true) {
          setsubmitLoader(false);
          showSuccessAlert(res?.data?.message);
        } else {
          showErrorAlert(res.data?.message);
          setsubmitLoader(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setsubmitLoader(false);
      }
    );
  }

  const onimageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ];
      if (validImageTypes.includes(file.type)) {
        setValueObj({ ...ValueObj, image: file });
        setimage(URL.createObjectURL(file));
      } else {
        showErrorAlert("Select a proper image (JPG, PNG, WEBP)");
      }
    }
  };

  const onvideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "video/mp4") {
        setValueObj({ ...ValueObj, video: file });
        setvideo(URL.createObjectURL(file));
      } else {
        showErrorAlert("Please select the video file only");
      }
    }
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Bio And Video</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Bio And Video</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            <div className="row">
              <div className="col-8">
                <div className="form-group">
                  <label>Title<sup className="error">*</sup></label>
                  <input
                    type="text"
                    placeholder="Title"
                    className="form-control"
                    value={ValueObj?.title || ""}
                    onChange={(e) => {
                      setValueObj({ ...ValueObj, title: e.target.value });
                    }}
                  />
                  {error && !ValueObj?.title && (
                    <div className="error mt-1">Title is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Short Bio<sup className="error">*</sup></label>
                  <input
                    type="text"
                    placeholder="Bio"
                    className="form-control"
                    value={ValueObj?.bio || ""}
                    onChange={(e) => {
                      setValueObj({ ...ValueObj, bio: e.target.value });
                    }}
                  />
                  {error && !ValueObj?.bio && (
                    <div className="error mt-1">Bio is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Description<sup className="error">*</sup>
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={ValueObj?.description}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setValueObj({ ...ValueObj, description: data });
                    }}
                  />
                  {error && !ValueObj?.description && (
                    <div className="error mt-1">Description is required</div>
                  )}
                </div>
              </div>
              <div className="col-4 text-center">
                <div className=" ">
                  <img
                    src={image}
                    alt="..."
                    className="CommonImage"
                    onError={(e) => {
                      e.target.src = defaultImg;
                    }}
                  />
                  {error && !image && (
                    <div className="error text-center mt-1">
                      Image is required
                    </div>
                  )}

                  <div className="mt-2">
                    <span className="btn btn-primary position-relative">
                      Select Image
                      <span>
                        <input
                          type="file"
                          name="image"
                          accept=".jpg,.jpeg,.png"
                          className="btn-input position-absolute"
                          style={{ opacity: 0 }}
                          onChange={(e) => onimageUpload(e)}
                        />
                      </span>
                    </span>
                  </div>
                </div>{" "}
                <hr />
                <div className="mt-3">
                  <video src={video} className="CommonImage" controls></video>
                  {error && !video && (
                    <div className="error text-center mt-1">
                      Video is required
                    </div>
                  )}

                  <div className="mt-2">
                    <span className="btn btn-primary position-relative">
                      Select Video
                      <span>
                        <input
                          type="file"
                          accept=".mp4"
                          className="btn-input position-absolute"
                          style={{ opacity: 0 }}
                          onChange={(e) => onvideoUpload(e)}
                        />
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => submit()}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
            <MoonLoader
              color={"#003bff"}
              loading={loading}
              speedMultiplier={0.6}
              size={50}
            />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
